import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import * as R from "ramda";
import { Link } from "react-router-dom";
import Truncate from "react-truncate";

import Text from "components/Text";

import styles from "./MapPopup.scss";

const PermissionBubble = ({ category, effectiveZone }) => {
  const displayName = R.path(["permission", "display_name"], effectiveZone) || category;
  const permissionDescription = R.path(["permission", "description"], effectiveZone) || "";

  return (
    <div>
      <header className={classnames(styles.header, styles[category])}>{displayName}</header>
      <div className={styles.content}>
        <div>
          <Truncate lines={5}>{permissionDescription}</Truncate>
        </div>
        <div className={styles.learnMoreContainer}>
          <Link data-learn-more to="location/zoning-details">
            <Text t="guides.location.learn_more" />
          </Link>
        </div>
      </div>
    </div>
  );
};

PermissionBubble.propTypes = {
  category: PropTypes.string.isRequired,
};

export default PermissionBubble;
